import { render } from "./VideoJs.vue?vue&type=template&id=72c7d956"
import script from "./VideoJs.vue?vue&type=script&lang=js"
export * from "./VideoJs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__